<!--scan-summary:区域扫描统计 2025/05/21 14:26:56 YuAng-->
<template>
  <div class="scan-summary">
    <page-header :paths="['扫描批次','全区数据']" :title="exam.examName">
      <el-button :loading="downloadLoading" type="text" style="float: right;" @click="exportStudent()" size="mini">
        未上传名单
        <span class="el-icon-download"></span>
      </el-button>
    </page-header>
    <div class="list-wrapper">
      <div class="list-title">
        <div v-if="notUploadInfo.schoolCount > 0 && notUploadInfo.studentCount > 0">
          该考试现有
          <span class="red-text">{{ notUploadInfo.schoolCount }}</span>所学校
          <span class="red-text">{{ notUploadInfo.studentCount }}</span>名学生
          未上传答题卡，这些学生将没有成绩
          <el-button type="text" @click="jumpDetail()" size="mini">去查看</el-button>
        </div>
        <el-input v-model="search.keyWord" placeholder="搜索学校" prefix-icon="el-icon-search" clearable @clear="handleLogCurrentChange(1)" @keyup.enter.native="handleLogCurrentChange(1)" style="width: 200px;"></el-input>
      </div>
      <div class="list-item">
        <el-table :data="schoolList" border @sort-change="handleSortChange" :default-sort="{ prop: 'totalCount', order: 'descending' }">
          <el-table-column align="center" prop="schoolName" label="学校">
          </el-table-column>
          <el-table-column align="center" width="100" prop="totalCount" label="计划总量" sortable :sort-orders="['descending', 'ascending']">
          </el-table-column>
          <el-table-column align="center" width="100" prop="uploadedCount" label="已上传量" sortable :sort-orders="['descending', 'ascending']">
          </el-table-column>
          <el-table-column align="center" width="100" prop="rceCount" label="已识别量" sortable :sort-orders="['descending', 'ascending']">
          </el-table-column>
          <el-table-column align="center" width="100" prop="unUploadCount" label="未上传量" sortable :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span :class="scope.row.unUploadCount > 0 ? 'red-text' : ''">{{ scope.row.unUploadCount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" prop="noNamePaperCount" label="无名卷量" sortable :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span :class="scope.row.noNamePaperCount > 0 ? 'red-text' : ''">{{ scope.row.noNamePaperCount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" prop="absentCount" label="缺考" sortable :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span :class="scope.row.absentCount > 0 ? 'red-text' : ''">{{ scope.row.absentCount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" prop="zeroCount" label="0分卷" sortable :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span :class="scope.row.zeroCount > 0 ? 'red-text' : ''">{{ scope.row.zeroCount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" prop="schoolId" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="jumpDetail(scope.row)" size="mini">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <yue-pagination v-if="page.total > page.size" :page="page" @current-change="handleLogCurrentChange" style="margin-top: 20px;"></yue-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/v2/views/components/PageHeader.vue'
import { getExam } from "@/api/exam/exam";
import examApi from '../utils/api';
import { mapGetters } from 'vuex'
export default {
  components: { PageHeader },
  name: 'scan-summary',
  data () {
    return {
      examId: '0',
      exam: {},
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      search: {
        direction: "DESC",// 排序方式
        orderProperty: 'totalCount',// 排序字段
        keyWord: '', // 关键字
      },
      schoolList: [],
      loading: false,
      notUploadInfo: {
        schoolCount: 0,
        studentCount: 0
      },
      downloadLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  mounted () {
    this.examId = this.$route.params.id;
    this.getExamNotUploadCount()
    this.getExamInfo()
  },
  methods: {
    getExamNotUploadCount () {
      examApi.getExamNotUploadCount({ examId: this.examId }).then(res => {
        if (res.success) {
          this.notUploadInfo = res.body
        }
      })
    },
    // 获取当前考试信息
    async getExamInfo () {
      let resp = await getExam(this.examId);
      if (resp.body) {
        this.exam = resp.body
        if (this.exam.isAdd != 0) {
          this.exam.examName += '（附加卷）'
        }
        if (this.exam.isTwo != 0) {
          this.exam.examName += '（二卷）'
        }
        this.handleLogCurrentChange(1)
      }
    },
    // 获取扫描卷汇总信息
    async getScanPaperSummary () {
      const params = {
        examId: this.examId,
        ...this.search,
        currentPage: this.page.current,
        pageSize: this.page.size,
      }
      this.loading = true
      let resp = await examApi.getScanPaperSummary(params);
      this.loading = false
      if (resp.success && resp.body) {
        const data = resp.body
        this.schoolList = data.items
        this.page.total = resp.body.totalSize;
      }
    },
    // 切换页码
    handleLogCurrentChange (val) {
      this.page.current = val;
      this.getScanPaperSummary();
    },
    // 排序
    handleSortChange (row) {
      const { prop, order } = row
      let direction = order === 'ascending' ? 'ASC' : 'DESC'
      if (prop !== this.search.orderProperty || direction !== this.search.direction) {
        this.search.orderProperty = prop
        this.search.direction = order === 'ascending' ? 'ASC' : 'DESC'
        this.handleLogCurrentChange(1)
      }
    },
    // 导出学生名单
    exportStudent () {
      const params = {
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
        type: 'UN_UPLOAD',
        allStudent: true
      }
      this.downloadLoading = true
      examApi.exportStudent(params).then(resp => {
        this.downloadLoading = false
        if (resp.body) {
          window.open(resp.body, "_blank");
        }
      })
    },
    jumpDetail (row) {
      let name = 'student-answer'
      if (this.exam.importType === 'IMPORT') {
        name = 'student-view'
      }
      let url = `/exam/answer/${name}/${this.exam.id}`
      if (row) {
        url += '?schoolId=' + row.schoolId
      }
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.list-wrapper {
  background-color: #fff;
  padding: 20px;
}
.list-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.red-text {
  color: #f53f3f;
}

.scan-summary {
  padding: 0 calc(50% - 600px);
}
</style>